import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { Title } from '../Title/Title';
import Triangle from '../Triangle/Triangle';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import { useTranslation } from 'react-i18next';
import { DropDown } from './Components/DropDown';
import FrequentImage from '../assets/FrequentImage.png';
import { renderParagraphsJson } from '../../../../../utils/utils'
import { frequentQuestions } from '../../../../../models/frequent-questions';

const Faq = forwardRef<HTMLDivElement>((props, ref) => {
  const [expanded, setExpanded] = useState<number | null>(null);
  const { t } = useTranslation();

  return (
    <Background ref={ref} id='FAQ'>
      <Triangle color='#a8e8d3' />
      <LandingWrapper>
        <Image src={FrequentImage} alt='Frequent Image' />
        <Title text={t('landing.frequent-questions.title')} justification='left' />
        <Wrapper>
          {frequentQuestions.map((q, i) => (
            <DropDown
              key={i}
              id={i}
              title={t(`landing.frequent-questions.${q.title}`)}
              content={renderParagraphsJson(t(`landing.frequent-questions.${q.content}`))}
              expanded={expanded}
              setExpanded={setExpanded}
              category='faq'
            />
          ))}
        </Wrapper>
      </LandingWrapper>
      <Triangle orientation='bottom' position='right' color='#a8e8d3' />
    </Background>
  );
});

export default Faq;

const Image = styled.img`
  width: 50%;
  align-self: center;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    max-width: 372px;
  }
`;

const Wrapper = styled.div`
  margin: 0;
  padding: 40px 0;

  @media (min-width: 768px) {
    padding: 48px 0;
  }
`;

const Background = styled.div`
  width: 100%;
  background-color: #a8e8d3;
  position: relative;
  padding-bottom: 80px;
  scroll-margin-top: 190px;

  @media (min-width: 500px) {
    padding-bottom: 120px;
  }

  @media (min-width: 650px) {
    padding-bottom: 180px;
  }

  @media (min-width: 768px) {
    padding-bottom: 200px;
  }
`;
